import React from 'react';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { fmtDT } from '@/components/ewayBill/shared';

const HEADS = ['Supplier', 'GSTIN', 'Address', 'Place – PIN', 'State', 'Last used', ''];

export const GstinTag = ({ gstin }) => (gstin === 'URP'
  ? <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-800">Unregistered</span>
  : <span className="font-mono text-xs">{gstin}</span>);

/** Saved inward senders — Admin can tick duplicates to merge them. */
export const SupplierTable = ({ rows, canMerge, picked, onToggle, onEdit }) => (
  <div className="overflow-x-auto rounded-xl bg-white shadow-sm">
    <Table data-testid="suppliers-table">
      <TableHeader><TableRow>{canMerge && <TableHead className="w-8" />}{HEADS.map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
      <TableBody>
        {rows.map((s) => (
          <TableRow key={s.id} className={picked.has(s.id) ? 'bg-violet-50' : 'hover:bg-slate-50'} data-testid={`supplier-row-${s.id}`}>
            {canMerge && <TableCell><Checkbox checked={picked.has(s.id)} onCheckedChange={() => onToggle(s.id)} data-testid={`supplier-pick-${s.id}`} /></TableCell>}
            <TableCell className="font-semibold" data-testid={`supplier-name-${s.id}`}>{s.legal_name}</TableCell>
            <TableCell data-testid={`supplier-gstin-${s.id}`}><GstinTag gstin={s.gstin} /></TableCell>
            <TableCell className="max-w-[260px] truncate text-xs text-gray-600">{[s.address1, s.address2].filter(Boolean).join(', ')}</TableCell>
            <TableCell className="whitespace-nowrap text-xs">{s.place} – <span className="font-mono">{s.pincode}</span></TableCell>
            <TableCell className="text-xs">{s.state}</TableCell>
            <TableCell className="whitespace-nowrap text-xs text-gray-500">{s.last_used_at ? fmtDT(s.last_used_at) : 'Added by hand'}</TableCell>
            <TableCell><Button size="sm" variant="ghost" onClick={() => onEdit(s)} data-testid={`supplier-edit-${s.id}`}><Pencil className="w-4 h-4" /></Button></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default SupplierTable;
